import React, { FC, useMemo, useCallback } from 'react';
import { ArgsInput } from './BasicComponents';
import { OperatorProps } from '../../../../@types/TemplateOperators';

const Constant: FC<OperatorProps> = ({ step, handleArgsChange }) => {
  const initialValue = useMemo(() => {
    if (typeof step.args[0] === 'string') {
      return step.args[0];
    } else {
      return '';
    }
  }, [step]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback((value: string) => handleArgsChange([value]), []);

  return (
    <div className="flex mt-6 w-1/2" data-testid="constant-operator">
      <ArgsInput
        initialValue={initialValue}
        onChange={handleChange}
        placeholder={step.operation}
        label="term"
        subLabel="Value that will always be used"
      />
    </div>
  );
};

export default Constant;
